import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const NoneData = memo(props => {
	const classes = useStyles();
	const { height } = props;

	return (
		<Grid
			classes={{ root: classes.rootNonData }}
			style={{ height: height }}
		>
			<img
				src={Images.logoNonData}
				alt={"logoNonData"}
				width={124}
				height={150}
			/>
		</Grid>
	);
});

export default NoneData;
